import React from 'react';
export function Modules() {
  const modules = [{
    num: '01',
    week: 'Días 1 — 5',
    name: 'MENTALIDAD DEL ARQUITECTO',
    desc: 'Elimina las creencias que te tienen en modo "empleado digital". Descubre el modelo del Creador Proxy y valida tu nicho de mercado global.'
  }, {
    num: '02',
    week: 'Días 6 — 10',
    name: 'EL ARSENAL PROXY',
    desc: 'Setup completo de tu Exoesqueleto Digital. Configura las 6 herramientas de IA. Tu primer flujo de producción en 48 horas.'
  }, {
    num: '03',
    week: 'Días 11 — 15',
    name: 'DISEÑO DE AUTORIDAD GLOBAL',
    desc: 'Domina el diseño IA para crear interfaces que justifican precios de $2,000 - $5,000. Construye tu portafolio de alto impacto.'
  }, {
    num: '04',
    week: 'Días 16 — 20',
    name: 'INGENIERÍA SINTÉTICA',
    desc: 'Construye tu primera Web-App funcional con IA. De la idea al producto desplegado en menos de 72 horas.'
  }, {
    num: '05',
    week: 'Días 21 — 25',
    name: 'MONETIZACIÓN HIGH-TICKET',
    desc: 'Los 3 modelos de negocio del Arquitecto Proxy. Scripts de cierre para contratos de $1,000 - $5,000.'
  }, {
    num: '06',
    week: 'Días 26 — 28',
    name: 'ESCALA Y AUTOMATIZACIÓN',
    desc: 'De freelancer a dueño de sistema. Micro-SaaS con ingresos recurrentes. Tu flywheel de activos digitales.'
  }, {
    num: '07',
    week: 'Días 29 — 30',
    name: 'SOBERANÍA TECNOLÓGICA',
    desc: 'Tu hoja de ruta para pasar de "operador" a "dueño del sistema". Arbitraje geográfico y diversificación.'
  }];
  return <section className="py-8 md:py-[120px] px-4 md:px-12 relative z-10" aria-label="Módulos del Ebook" data-id="element-148">
      <div className="max-w-[1000px] mx-auto" data-id="element-149">
        <div className="text-center mb-8 md:mb-20" data-id="element-150">
          <span className="section-tag" data-id="element-151">El Mapa</span>
          <h2 className="font-display text-[clamp(2.2rem,5vw,5rem)] tracking-[3px] leading-none mb-3 md:mb-4" data-id="element-152">
            30 DÍAS.
            <br data-id="element-153" />7 MÓDULOS.
            <br data-id="element-154" />1 SISTEMA.
          </h2>
          <p className="font-text text-[0.85rem] md:text-[1rem] text-text-silver max-w-[500px] mx-auto" data-id="element-155">
            Sin relleno. Sin teoría vacía. Solo el mapa exacto para construir tu
            primer activo digital de alto ticket.
          </p>
        </div>

        <div className="flex flex-col relative" data-id="element-156">
          <div className="absolute left-[19px] md:left-[23px] top-0 bottom-0 w-px bg-gradient-to-b from-gold to-gold/10" aria-hidden="true" data-id="element-157" />
          {modules.map((mod, idx) => <div key={idx} className="grid grid-cols-[40px_1fr] md:grid-cols-[48px_1fr] gap-3 md:gap-8 py-4 md:py-8 border-b border-border last:border-b-0 group cursor-default" data-id="element-158">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-bg-void border border-border-glow flex items-center justify-center font-display text-[0.85rem] md:text-[1rem] text-gold shrink-0 relative z-10 transition-all duration-[350ms] group-hover:bg-gold group-hover:text-black group-hover:shadow-[0_0_20px_rgba(255,215,0,0.3)]" data-id="element-159">
                {mod.num}
              </div>
              <div className="py-1 md:py-2 transition-transform duration-[350ms] group-hover:translate-x-2" data-id="element-160">
                <div className="text-[0.55rem] md:text-[0.65rem] tracking-[3px] text-gold uppercase mb-1" data-id="element-161">
                  {mod.week}
                </div>
                <h3 className="font-display text-[1.15rem] md:text-[1.5rem] tracking-[2px] text-white mb-1.5 md:mb-3 leading-[1.2]" data-id="element-162">
                  {mod.name}
                </h3>
                <p className="text-[0.78rem] md:text-[0.9rem] text-text-muted leading-[1.6]" data-id="element-163">
                  {mod.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}